import React, { Component } from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import { Button, Table, Clearfix } from 'react-bootstrap'
import Api from '../../../../Global/Modules/Api'

class BeoordelingsDocumenten extends Component {
    constructor() {
        super();
        this.handlePaginationClick = this.handlePaginationClick.bind(this)
        this.handleDelete = this.handleDelete.bind(this)
        this.handleClickVerk = this.handleClickVerk.bind(this)
        this.getKennis = this.getKennis.bind(this)
        this.state = {
            kennis: [],
            pagination: {
                totalPages: 0,
                currentPage: 0,
                pageSize: 0,
                totalCount: 0
            },
            currentFetchUrl: '', // To know where to fetch (to refresh companies) if a company is deleted
        }
    }
    componentWillMount() {
        const FETCH_URL = "api/members/" + this.props.id + "/assestments"
        this.setState({ currentFetchUrl: FETCH_URL })
        this.getKennis(FETCH_URL)
    }

    handleDelete = id => event => {
        event.preventDefault()
        const FETCH_URL_DELETE = `api/members/${id}/assestment`
        if (window.confirm('Are you sure you wish to delete this item?')) {
            Api.print(`DELETE ${FETCH_URL_DELETE}`)
            Api.DeleteApi(FETCH_URL_DELETE).then(response => {
                Api.print(`Response delete company with id: ${id}`)
                Api.print(response)
                this.getKennis(this.state.currentFetchUrl) // Update the companies list
            })
        }
    }

    handleClickVerk(e) {
        var url = "api/members/" + e + "/getDoc";
        Api.GetApiDownload(url)
    }
    handlePaginationClick(e) {
        const FETCH_URL3 = e === "prev" ? this.state.pagination.prev : this.state.pagination.next;
        this.setState({ currentFetchUrl: FETCH_URL3 })
        this.getKennis(FETCH_URL3)
    }
    getKennis(fetchUrl) {
        Api.GetTableApi(fetchUrl, this.handlePaginationClick).then(response => {

            this.setState({ pagination: response.pagination }) // Pagination object 
            return response.data.json() // Data -> companies object
        }).then(objectData => {
            if (objectData !== undefined)
                this.setState({ kennis: objectData }); // Companies object
        })
    }
    render() {
        let kennis = this.state.kennis;
        let item = this.props.id;
        return (
            <div>
                <LinkContainer to={"/admin/leden/lid/beoordelingsdocumenten/toevoegen/" + item}><Button className="pull-right">Toevoegen document</Button></LinkContainer>
                <Clearfix />
                <h5><strong>Beoordelings documenten</strong></h5>
                <div>
                    <div>Resultaten  {(this.state.pagination.pageSize == '0' || this.state.pagination.pageSize > this.state.pagination.totalCount) ? this.state.pagination.totalCount : this.state.pagination.pageSize} van {this.state.pagination.totalCount}</div>
                    <Table responsive striped bordered hover className="text-center">
                        <thead>
                            <tr>
                                <th>datum</th>
                                <th>opmerkingen</th>
                                <th>Bewerk</th>
                                <th>bekijk</th>
                                <th>verwijder</th>
                            </tr>
                        </thead>
                        <tbody>
                            {kennis !== undefined ? kennis.map((comp) => {
                                //let editUrl = `/admin/kennis/bijeenkomst/bewerken/${comp.id}`
                                return (<tr key={comp.id}>
                                    <td>{Api.formatDateAndTime(comp.dateUpdatedUtc)}</td>
                                    <td>{comp.comments}</td>
                                    <td><LinkContainer to={"/admin/leden/lid/beoordelingsdocumenten/bewerken/" + comp.id +"/"+item}><Button bsSize="xsmall" >bewerk</Button></LinkContainer></td>
                                    <td><a onClick={() => this.handleClickVerk(comp.id)} target="_blank" title={"Bekijk documenten"}>bekijk<br /></a></td>
                                    <td><Button bsSize="xsmall" className="delete" onClick={this.handleDelete(comp.id)}>
                                        verwijder
                                    </Button></td>
                                </tr >)
                            }) : null}
                        </tbody>
                    </Table>
                    <div className="paginationStyling">
                        <div style={{ float: 'left' }}>
                            {this.state.pagination.prevButton}
                        </div>
                        <div style={{ float: 'center' }}>
                            Pagina {this.state.pagination.currentPage} van {this.state.pagination.totalPages}
                        </div>
                        <div style={{ float: 'right' }}>
                            {this.state.pagination.nextButton}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default BeoordelingsDocumenten;




// WEBPACK FOOTER //
// ./src/components/Admin/Modules/Leden/Lid/BeoordelingsDocumenten.js